<p *ngIf="langue.l == 'fr'">
    Tout sort lancé possède 4 caractéristiques :<br/>
    Taille - Distance - Efficacité - Précision<br/>
    <br/>
    Par défaut : lancer <b>Xd4</b> où X est la sensitivité de la source.<br/>
    Si X est inférieur à 4, alors le joueur lance un nombre de d2 pour arriver à 4 dés.<br/>
    Choisit dans quelle catégorie va chaque dé<br/>
    Ne peut pas "couper" de dé<br/>
    Minimum 1 dans chaque carac pour que le sort fonctionne<br/>
    Pas obligé d'utiliser tous les dés<br/>
    Ajoute les résultats des dés dans la même carac, 1+1 = même résultat que 2<br/>
    <br/>
    Une fois les caractéristiques choisies, le mage peut <b>étendre la Taille de son sort</b>.<br/>
    Dans ce cas, il diminue de 1 la taille effective, et augmente de 1 la taille couvrante.
    Les dégâts sont calculés avec la taille effective, les créatures affectées sont déterminées avec la taille couvrante.
    Cette "étalage" de la taille d'un sort représente la diminution de l'espace occupé dans une dimension pour l'augmenter dans une autre.<br/>
    Ceci est utilisable deux fois maximum par sort.<br/>
</p>
<p *ngIf="langue.l == 'en'">

</p>

<h3 *ngIf="langue.l == 'fr'">Bonus de dés</h3>
<h3 *ngIf="langue.l == 'en'">Bonus dice</h3>

<p *ngIf="langue.l == 'fr'">
    La spécialisation d'une magie correspond à un nombre donné représentant l'entraînement et la force de l'affinité que la personne a avec cette magie.<br/>
    Un personnage commence avec un +1 dans sa magie majeure, un +1 dans sa combinée et un +0 dans sa mineure.<br/>
    Il est possible de décider de transférer sa spécialisation de sa majeure vers sa combinée, ou vice versa. Auquel cas il y aura un +2 et un +0.<br/>
    Cette spécialisation permet une amélioration des sorts lancés de cette magie.<br/>
    À chaque lancé de sort, après avoir réparti les dés et avoir calculé la puissance du sort,
    un mage peut ajouter sa spécialisation sur une des caractéristiques du sort.
    Si c'est un +2, à considérer comme deux +1 indépendants cummulables.<br/>
    <br/>
    Détail : Si une caractéristique n'a pas de dé ou est à 0, le sort ne marche pas. De plus, il est impossible d'ajouter un +1 sur une caractéristique sans dé.<br/>
    <br/>
    Un mage lance un nombre de d4 égal à sa sensitivité, et des d2 pour combler jusqu'à 4 dés si la sensitivité est trop faible.<br/>
    <br/>
    Puissance = somme de tous les dés utilisés (sans compter les +1 de magie primaire ou autres bonus/malus)<br/>
    La puissance d'un sort détermine son "niveau".<br/>
    Si le sort est purement visuel (équivalent de puissance 4) et qu'aucun dé n'a été lancé, il est de niveau 0, et ne coûte pas d'énergie.<br/>
    Si le sort a une puissance entre 5 et 9, il est de niveau 1 et coûte 1 point d'énergie.<br/>
    Si le sort a une puissance entre 10 et 14 inclus, il est de niveau 2 et coûte 2 points d'énergie.<br/>
    Si le sort a une puissance entre 15 et 19 inclus, il est de niveau 3 et coûte 3 points d'énergie.<br/>
    Les niveaux de sorts continuent à suivre la puissance du sort par fourchette de 5 et coûtent de plus en plus cher, suivant les règles déjà établies.<br/>
</p>
<p *ngIf="langue.l == 'en'">

</p>

<h3 *ngIf="langue.l == 'fr'">Attaque</h3>
<h3 *ngIf="langue.l == 'en'">Attack</h3>

<p *ngIf="langue.l == 'fr'">
    Il existe trois types d'attaques magiques : l'attaque directe sur l'ennemis, le lancé, et l'attaque psychologique.
    Ces attaques suivent les mêmes règles de résultats spéciaux que les attaques armées
    (cf <a routerLink="/system/attacking/hitting" routerLinkActive="activebutton">tableau de toucher</a>)
    sachant que les continuations et coups critiques (ignore résistance naturelle) ne sont disponibles qu'aux armes et pas aux attaques magiques.<br/>
    <b>Attaque directe</b> : exemple : création d'une boule de feu autour d'un ennemis, prise de contrôle de la terre sous les pieds de quelqu'un et faire un trou.<br/>
    Dans ce cas là, le jet d'attaque est <b>1d12 + (précision x2) contre l'esquive</b> de l'ennemis, et les degâts sont efficacité + taille - résistance.<br/>
    <b>Lancé</b> : création d'une boule de feu dans les mains du mage et lancé vers l'ennemis, prise de contrôle de glace pour faire des piques et lancé vers l'ennemis.<br/>
    Dans ce cas là, le jet d'attaque est <b>1d12 + (précision + Dex) contre l'esquive</b> de l'ennemis, et les degâts sont efficacité + taille - résistance.<br/>
    <b>Attaque psychologique</b> : prise de contrôle partielle de l'esprit de l'ennemis pour le ralentir, illusion.<br/>
    Dans ce cas là, le jet d'attaque est <b>1d12 + (précision x2) contre la sensitivité</b> de l'ennemis, et les degâts n'existent pas mais les résultats dépendront des caractéristiques du sort.<br/>
    <br/>
    Pour ce calcul, on considère que la valeur de la taille est majorée par la taille de la cible.
    Par exemple : Une personne fait face à un humain et un renard.
    La personne lance un sort possèdant 3 en efficacité, et 5 en taille.
    Le 5 en taille permet de cibler un groupe, donc le sort affectera l'humain cible et le renard cible.
    À cause de leur différence de taille, l'humain prendra 3+4 dégâts bruts, et le renard 3+3.
    Grâce à leurs résistances respectives, l'humain subira 3+4-2 de douleur, et le renard 3+3-1.
    Le renard tombe inconscient et l'humain n'est que blessé.
    (cf <a routerLink="/system/magic/ballparks" routerLinkActive="activebutton">ordres de grandeurs</a>)<br/>
</p>
<p *ngIf="langue.l == 'en'">

</p>
